import {
    columnFacetingFeature,
    columnFilteringFeature,
    columnResizingFeature,
    columnSizingFeature,
    columnVisibilityFeature,
    createFacetedRowModel,
    createFacetedUniqueValues,
    createFilteredRowModel,
    createPaginatedRowModel,
    createSortedRowModel,
    filterFn_equals,
    filterFn_includesString,
    rowPaginationFeature,
    rowSortingFeature,
    tableFeatures
} from "@tanstack/react-table";
import type { Column, ReactTable, RowData } from "@tanstack/react-table";

import { reactTableFilterFns } from "./filterFns";

export const reactTable2Features = tableFeatures({
    columnVisibilityFeature,
    columnSizingFeature,
    columnResizingFeature,
    columnFilteringFeature,
    columnFacetingFeature,
    rowSortingFeature,
    rowPaginationFeature,
    filteredRowModel: createFilteredRowModel(),
    sortedRowModel: createSortedRowModel(),
    paginatedRowModel: createPaginatedRowModel(),
    facetedRowModel: createFacetedRowModel(),
    facetedUniqueValues: createFacetedUniqueValues(),
    filterFns: {
        includesString: filterFn_includesString,
        equals: filterFn_equals,
        ...reactTableFilterFns
    }
});

export type ReactTable2Table<TData extends RowData = any> = ReactTable<typeof reactTable2Features, TData>;
export type ReactTable2Column<TData extends RowData = any, TValue = unknown> = Column<typeof reactTable2Features, TData, TValue>;
